import Grid from '@mui/material/Grid';
import React, { useContext } from 'react';
import { useLocation} from "react-router-dom";
import { format } from 'react-string-format';
import { Nav } from 'reactstrap';
import useMyMApi from '../../hooks/useMyMApi';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MenuBar } from '../../ui-parts/MenuBar';
import { MenuNavItem, HamburgerMenuItem } from '../../ui-parts/MenuNavItem';
import Help from '../MyM908_Help/Help';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import useWebContext from '../../hooks/useWebContext';
import ListItem from '@mui/material/ListItem';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { utility } from '../../utility';

/**
 * FooterBar Component
 * @param {object} param0 - コンポーネントプロパティ
 * @param {object} param0.controlSettings - controlSettings定義
 */
const FooterBar = ({ controlSettings }) => {

  const isPc = useMediaQuery(mediaQuery.pc);
  const isTopPage = useLocation().pathname === '/';

  // トップページではない 且つ ウィンドウがPCサイズではない場合、フッタは表示しない
  if (!isTopPage && !isPc)
    return <></>

  return (
    <MenuBar>
      {/* 2024.9.16 MyMine Version2.0対応 Modify Start */}
      <Grid item md={12} lg={9}>
        <Nav style={{ justifyContent: isPc ? 'start' : 'space-between' }}>
          <FooterMenuItems />
        </Nav>
      </Grid>
      <Grid item md={12} lg={3} className="d-flex align-items-center justify-content-end">
        <MyMLabel fontSize='14px'>{format(controlSettings.LabelList.lblHCMCopyrightNotice, (new Date()).getFullYear())}</MyMLabel>
      </Grid>
      {/* 2024.9.16 MyMine Version2.0対応 Modify End */}
    </MenuBar>
  );
}
export default FooterBar;

// 2024.9.16 MyMine Version2.0対応 Modify Start
// Mobile/Tablet表示対応の対応のため、コンポーネント部品を切り出し
/**
 * フッタメニュー項目
 * @param {object} param0 - コンポーネントプロパティ
 * @param {boolean} param0.isHamburger - ハンバーガーメニュー表示要否
 * @param {function} param0.handleClose - メニューを閉じるための関数
 */
export const FooterMenuItems = ({ isHamburger, handleClose }) => {

  const screenId = 'MyM902';
  const { controlSettings } = useWebContext(screenId);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isHelpOpen, setIsHelpOpen] = React.useState(false);
  const handleHelpOpen = () => setIsHelpOpen(true);
  const handleHelpClose = () => setIsHelpOpen(false);
  const apiRequest = useMyMApi(screenId);
  const isPc = useMediaQuery(mediaQuery.pc);
  const { setAuthUser } = useContext(AuthUserContext);
  const isMobile = useMediaQuery('(max-width:499px)');

  const onClickDownload = (e, fileId) => {
    setIsLoading(true);

    const downloadCallback = () => {
      setIsLoading(false);
    }

    apiRequest.download('api/page/manual', downloadCallback, downloadCallback);
  }

  const isTopPage = useLocation().pathname === '/';

  /*2025.7.7 MyMine Version3.0対応 Add Start*/
  const onClickLogout = () => {
    setAuthUser(null);
    utility.transferTopPage();
  };

  /*2025.7.7 MyMine Version3.0対応 Add End*/

  const menuList = isTopPage ?
    [
      { labelId: 'lnkTermsOfUse', needsOpenTab: true, linkTo: '/MyM904' },
      { labelId: 'lnkPrivacyPolicy', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/privacy/', },
      { labelId: 'lnkRegistrationSupport', needsOpenTab: false, linkTo: '#', onClickAction: handleHelpOpen, },
      { labelId: 'lnkHCMGlobal', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/', },
    ]
    :
    isPc ?

    [
      { labelId: 'lnkTermsOfUse', needsOpenTab: true, linkTo: '/MyM904', },
      { labelId: 'lnkPrivacyPolicy', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/privacy/', },
      // 2025.7.7 MyMine Version3.0対応 Add Start
      { labelId: 'lnkFAQ', needsOpenTab: false, linkTo: '/MyM102/MyM708', },
      // 2025.7.7 MyMine Version3.0対応 Add end
      // 2025.7.7 MyMine Version3.0対応 Modify Start
      // 2024.5.8 MyMine Version1.5対応 Modify Start
      { labelId: 'lnkSupport', needsOpenTab: false, linkTo: '/MyM102/MyM701', },
      // 2024.5.8 MyMine Version1.5対応 Modify End
      // 2025.7.7 MyMine Version3.0対応 Modify End
      { labelId: 'lnkHCMGlobal', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/', },
      { labelId: 'lnkUserManual', needsOpenTab: false, linkTo: '#', onClickAction: onClickDownload, },
      // 2025.7.7 MyMine Version3.0対応 Add Start
      { labelId: 'lnkMyProfile', needsOpenTab: false, linkTo: '/MyM102/MyM202', },
      // 2025.7.7 MyMine Version3.0対応 Add End
      ]
      :
      [
        // 2025.7.7 MyMine Version3.0対応 Add Start
        { labelId: 'lnkTermsOfUse', needsOpenTab: true, linkTo: `${process.env.REACT_APP_BASE_URL}/MyM904` },
        { labelId: 'lnkPrivacyPolicy', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/privacy/', },
        { labelId: 'lnkFAQ', needsOpenTab: false, linkTo: '/MyM102/MyM708', },
        { labelId: 'lnkSupport', needsOpenTab: false, linkTo: '/MyM102/MyM701', },
        { labelId: 'lnkHCMGlobal', needsOpenTab: true, linkTo: 'https://www.hitachicm.com/global/en/', },
        { labelId: 'lnkUserManual', needsOpenTab: false, linkTo: '#', onClickAction: onClickDownload, },
        // 2025.7.7 MyMine Version3.0対応 Add End
      ]
    ;

  return (
    <>
      {isLoading && <MyMProgress />}
      <MyMModal
        open={isHelpOpen}
        onClose={handleHelpClose}
        height='93%'
        width={isMobile ? '90vw' : 'auto'}
      >
        <Help handleClosePage={handleHelpClose} />
      </MyMModal>
      {menuList.map((menu, i) =>
        <React.Fragment key={i}>
          {
            isHamburger
              ? <HamburgerMenuItem
                handleClose={handleClose}
                menu={menu}
                menuText={controlSettings.LabelList[menu.labelId]} />
              : <MenuNavItem
                fontSize={17}
                linkTo={menu.linkTo}
                label={controlSettings.LabelList[menu.labelId]}
                onClickAction={menu.onClickAction}
                needsOpenTab={menu.needsOpenTab}>
              </MenuNavItem>
          }
        </React.Fragment>)}
      {/*2025.7.7 MyMine Version3.0対応 Add Start*/}

      {
        !isPc && isHamburger &&
        <ListItem
          sx={{
            height: 65,
            borderBottom: '1px solid #8080806e',
            ':hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
              backgroundColor: '#DDDDDD',
            },
          }}
          onClick={() => {
            handleClose();
            onClickLogout();
          }}
        >
          <LogoutIcon />
          <MyMLabel fontWeight='bold' sx={{ paddingLeft: '5px' }}>{controlSettings.LabelList.lnkLogout_Hamburger}</MyMLabel>
        </ListItem>
      }
      {/*2025.7.7 MyMine Version3.0対応 Add End*/}
    </>
  );
}
// 2024.9.16 MyMine Version2.0対応 Modify End